<template>
  <b-card>
    <div class="d-flex justify-content-between">
      <div class="text-left">
        <h2 :style="{ color: blobColor }">
          {{ value.toLocaleString() }}
        </h2>
        <small class="card-font">{{ label }}</small>
      </div>
      <div
        class="icon-container d-flex align-items-center justify-content-center px-1 py-1"
        :style="{ backgroundColor: iconBackgroundColor }"
      >
        <img :src="tileIcon">
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
  },
  props: {
    value: { type: Number, required: true },
    label: { type: String, required: true },
    blobColor: { type: String, default: '#00BBFF' },
    tileIcon: { type: String, default: '' },
  },
  computed: {
    arrowRotation() {
      return {
        pending: 'rotate(180deg)',
        in: 'rotate(225deg)',
        out: 'rotate(90deg)',
      }[this.arrowDirection] || 'rotate(0deg)'
    },
    iconBackgroundColor() {
      const hex = this.blobColor.replace('#', '')

      // Parse R, G, B from hex
      const r = parseInt(hex.substring(0, 2), 16)
      const g = parseInt(hex.substring(2, 4), 16)
      const b = parseInt(hex.substring(4, 6), 16)

      return `rgba(${r}, ${g}, ${b}, 0.2)` // 20% opacity
    },
  },
}
</script>

<style>
.card-font {
    font-weight: 700;
    font-size: 1rem;
}
.icon-container {
  background-color: aliceblue;
  border-radius: 12px;
}
</style>
